/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
var React = require("react");
var IconSVG = /** @class */ (function (_super) {
    tslib_1.__extends(IconSVG, _super);
    function IconSVG() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IconSVG.prototype.render = function () {
        return (React.createElement("svg", tslib_1.__assign({ role: "img", viewBox: "0 0 16 16" }, this.props),
            React.createElement("path", { d: "m15.5 2.1831v5.374c0 .414-.336.75-.75.75s-.75-.336-.75-.75v-.557h-12.5v5.912h5.1c.414 0 .75.336.75.75s-.336.75-.75.75h-5.85c-.414 0-.75-.336-.75-.75v-11.464c0-.414.336-.75.75-.75h2.35v-.698c0-.414.336-.75.75-.75h1.95c.414 0 .75.336.75.75v.683h2.4v-.683c0-.414.336-.75.75-.75h1.95c.414 0 .75.336.75.75v.683h2.35c.414 0 .75.336.75.75zm-1.5.75h-1.6v.683c0 .414-.336.75-.75.75h-1.95c-.414 0-.75-.336-.75-.75v-.683h-2.4v.683c0 .414-.336.75-.75.75h-1.95c-.414 0-.75-.336-.75-.75v-.668h-1.6v2.552h12.5zm-9.945.031h1.5v-1.548h-1.5zm5.88-.021h1.5v-1.547h-1.5zm4.631 8.968c0 .414-.336.75-.75.75h-1.849v2.089c0 .414-.336.75-.75.75s-.75-.336-.75-.75v-2.089h-1.85c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h1.85v-2.089c0-.414.336-.75.75-.75s.75.336.75.75v2.089h1.849c.414 0 .75.336.75.75z" })));
    };
    return IconSVG;
}(React.Component));
exports.IconSVG = IconSVG;